export default __webpack_public_path__ + "static/media/2.96dea6fc.png";